import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    serviceRequestTransaction:{
        isAdvance: false
    },
    serviceRequestTransactions:[]
}
const serviceRequestTransaction = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default serviceRequestTransaction;